import { LayoutGrid } from '@signozhq/icons';

import { QueryBuilderField } from 'components/QueryBuilderV2/queryBuilderFields.types';

import type { PanelDefinition } from '../../types/panelDefinition';
import { QueryModeKind } from '../../types/panelCapabilities';
import QueryBuilderEditorPane from 'pages/DashboardPage/DashboardContainer/PanelEditor/PanelEditorQueryBuilder/QueryBuilderEditorPane';
import Renderer from './Renderer';
import { sections } from './sections';
import {
	Querybuildertypesv5RequestTypeDTO,
	TelemetrytypesSignalDTO,
} from 'api/generated/services/sigNoz.schemas';
import { QueryMode } from 'types/api/queryBuilder/queryBuilderData';

export const definition: PanelDefinition<'signoz/HeatmapPanel'> = {
	kind: 'signoz/HeatmapPanel',
	displayName: 'Heatmap',
	mode: 'query',
	icon: LayoutGrid,
	Renderer,
	EditorPane: QueryBuilderEditorPane,
	sections,
	supportedQueryModesKindMap: {
		// Only metrics carry a bucket axis; the request rejects the other signals.
		[QueryMode.QUERY_BUILDER]: {
			kind: QueryModeKind.SIGNAL,
			signals: [TelemetrytypesSignalDTO.metrics],
		},
		[QueryMode.CLICKHOUSE]: { kind: QueryModeKind.SIGNAL_LESS },
		[QueryMode.PROM]: { kind: QueryModeKind.SIGNAL_LESS },
	},
	// The request rejects both: a point is a count per bucket, not a single value.
	queryBuilderFields: {
		[QueryBuilderField.Functions]: { state: 'hidden' },
		[QueryBuilderField.Having]: { state: 'hidden' },
	},
	// Every timestamp is a full column of cells, so the request asks for a step interval
	// wide enough to keep the grid legible: at raw resolution a multi-day range is tens of
	// thousands of cells, each of them sub-pixel.
	queryCapabilities: {
		requestType: Querybuildertypesv5RequestTypeDTO.heatmap,
		formatTableResultForUI: false,
		bucketedStepInterval: true,
		orderTiebreaker: false,
		serverPaginated: false,
	},
	actions: {
		view: true,
		edit: true,
		clone: true,
		download: { csv: false, png: true, svg: true },
		// A distribution per timestamp has no single value to threshold.
		createAlert: false,
		search: false,
		drilldown: false,
	},
};
